/**
 * Client Service
 *
 * Handles GraphQL operations for client management:
 * - Fetching all clients
 */

import { API } from 'aws-amplify';
import { listClients as listClientsQuery } from '../../../../../graphql/queries';

/**
 * Fetch all clients
 *
 * @returns {Promise<Array>} Array of client objects sorted by clientName
 * @throws {Error} If the GraphQL query fails
 */
export async function listClients() {
  try {
    const allClients = [];
    let nextToken = null;

    // Paginate through all clients
    do {
      const response = await API.graphql({
        query: listClientsQuery,
        variables: {
          limit: 1000,
          nextToken,
        },
      });

      const items = response.data.listClients.items;
      allClients.push(...items);
      nextToken = response.data.listClients.nextToken;
    } while (nextToken);

    // Sort clients by clientName
    allClients.sort((a, b) => {
      const nameA = a.clientName || a.clientId || '';
      const nameB = b.clientName || b.clientId || '';
      return nameA.localeCompare(nameB);
    });

    return allClients;
  } catch (error) {
    console.error('Error fetching clients:', error);
    throw new Error(`Failed to fetch clients: ${error.message}`);
  }
}
